import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useNoIndex } from "./useNoIndex";

export default function ControlLogin() {
  const { user, loginPlatform, logout } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useNoIndex();

  if (user?.is_platform_admin) return <Navigate to="/control-panel" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    if (user) await logout();
    const res = await loginPlatform(email, password);
    setBusy(false);
    if (res.ok) nav("/control-panel", { replace: true });
    else setErr(res.error);
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#0B1530] px-4" data-testid="control-login-page">
      <div className="pointer-events-none absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "radial-gradient(#C9A227 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
      <div className="pointer-events-none absolute -left-40 top-1/3 h-96 w-96 rounded-full bg-gold/10 blur-3xl" />
      <form onSubmit={submit} className="relative w-full max-w-md rounded-3xl border border-gold/20 bg-white/[0.04] p-10 shadow-2xl backdrop-blur-xl">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-gold/40 bg-gold/10 text-gold">
          <ShieldCheck size={26} />
        </div>
        <p className="mt-8 font-sans text-[11px] font-semibold uppercase tracking-[0.35em] text-gold/80">Zetland No. 508 · Restricted</p>
        <h1 className="mt-3 font-display text-4xl font-semibold text-parchment">Control Panel</h1>
        <p className="mt-2 font-sans text-sm text-parchment/55">Platform Administrators only. All sign-in attempts are recorded.</p>

        <label className="mt-9 block">
          <span className="mb-1.5 block font-sans text-xs font-semibold uppercase tracking-widest text-parchment/50">Email</span>
          <input type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 font-sans text-parchment outline-none transition-colors focus:border-gold/60"
            data-testid="control-login-email" />
        </label>
        <label className="mt-5 block">
          <span className="mb-1.5 block font-sans text-xs font-semibold uppercase tracking-widest text-parchment/50">Password</span>
          <input type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 font-sans text-parchment outline-none transition-colors focus:border-gold/60"
            data-testid="control-login-password" />
        </label>
        {err && <p className="mt-4 rounded-lg bg-garnet/20 px-4 py-2.5 font-sans text-sm text-parchment" data-testid="control-login-error">{err}</p>}
        <button type="submit" disabled={busy} className="btn-primary mt-8 w-full justify-center" data-testid="control-login-submit">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Lock size={16} />} Sign in securely
        </button>
      </form>
    </div>
  );
}
